import { Activity } from "react";
import Default from "./Default";
import * as styles from "./Skip.module.css";
import { useAppSelector } from "../app/hooks";

interface SkipProps {
  children?: React.ReactNode;
}

const Skip: React.FC<SkipProps> = ({ children }) => {
  const showSkipped = useAppSelector((state) => state.skipped.showSkipped);

  return (
    <div className={styles.outer}>
      <Default>{children}</Default>
      <Activity mode={showSkipped ? "visible" : "hidden"}>
        <div className={styles.overlay}>Skipping</div>
      </Activity>
    </div>
  );
};

export default Skip;
